// extracted by mini-css-extract-plugin
var _1 = "Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "Skeleton" }
